export default ({ COLORS }) => ({
  link: {
    color: COLORS.BLUE.NORMAL,
    textDecoration: 'none',
    fontWeight: 'bold'
  },
  date: {
    whiteSpace: 'nowrap'
  },
  checkboxChell: {
    borderLeft: `5px solid transparent`
  },
  unseen: {
    borderLeftColor: COLORS.RED.FADED
  },
  center: {
    textAlign: 'center'
  },
  btn: {
    padding: 0,
    fontSize: '16px'
  }
})
